var _LabeledPatientInformation;
import Component from '@glimmer/component';
import TitledLabel from 'ui-kit/components/titled-label';
import ProductName from 'core/components/product-name';
import PhoneLink from 'core/components/phone-link';
import t from 'ember-intl/helpers/t';
import formatDate from 'ember-intl/helpers/format-date';
import eq from 'ember-truth-helpers/helpers/eq';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class LabeledPatientInformation extends Component {
  titleize(string1) {
    return string1.toLowerCase().replace(/(?:^|\s|-|\/)\S/g, function (m1) {
      return m1.toUpperCase();
    });
  }
  getNestedProperty(obj1, path1) {
    return path1.split('.').reduce((acc1, key1) => acc1 && acc1[key1], obj1);
  }
  get propertyValue() {
    const value1 = this.args.patient?.[this.args.propertyName];
    if (this.args.propertyName.includes('.')) {
      return this.getNestedProperty(this.args.patient, this.args.propertyName);
    }
    if (this.args.format === 'titleize' && value1) {
      return this.titleize(value1);
    }
    return value1;
  }
  get hasValue() {
    return Boolean(this.propertyValue);
  }
}
_LabeledPatientInformation = LabeledPatientInformation;
setComponentTemplate(precompileTemplate("\n    {{#if this.hasValue}}\n      <div class=\"column\">\n        <TitledLabel data-test-label={{@propertyName}}>\n          <:title>\n            {{#if (eq @format \"code\")}}\n              {{@description}}\n              <ProductName />\n            {{else}}\n              {{@description}}\n            {{/if}}\n          </:title>\n          <:body>\n            {{#if (eq @format \"email\")}}\n              <a href=\"mailto:{{this.propertyValue}}\">{{this.propertyValue}}</a>\n            {{else if (eq @format \"gender\")}}\n              {{t \"patient.gender\" gender=this.propertyValue}}\n            {{else if (eq @format \"birthday\")}}\n              {{formatDate this.propertyValue format=\"DD/MM/YYYY\"}}\n            {{else if (eq @format \"phone\")}}\n              <PhoneLink @phone={{this.propertyValue}} />\n            {{else}}\n              {{this.propertyValue}}\n            {{/if}}\n          </:body>\n        </TitledLabel>\n      </div>\n    {{/if}}\n  ", {
  strictMode: true,
  scope: () => ({
    TitledLabel,
    eq,
    ProductName,
    t,
    formatDate,
    PhoneLink
  })
}), _LabeledPatientInformation);